import { Coding } from 'src/careflow/ph-core/fhir-client/resources';
import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';
import { getCodeableConceptDisplayName } from 'src/careflow/helpers/common';

export const ConditionWrapper = createWrapper('Condition', (condition) => ({
  getDisplay: () => condition?.code?.text ?? '',
  getConditionCoding: (): Coding => {
    const coding = condition?.code?.coding?.[0];
    return {
      ...(coding ?? {}),
      ...(coding ? { display: coding.display ?? condition?.code?.text } : {}),
    };
  },
  getSugestionCoding: (): Coding => {
    const coding = condition?.code?.coding?.[0];
    return {
      ...(coding ?? {}),
      ...(coding ? { display: coding.display ?? condition?.code?.text } : {}),
    };
  },
  getSeverityDisplay: (): string => {
    if (condition?.severity) {
      return getCodeableConceptDisplayName(condition.severity);
    }
    return '';
  },
}));
export type WrappedCondition = ReturnType<typeof ConditionWrapper>;
